import { defineStore } from "pinia"
import { Business } from "~/models/business"
import { Category } from "~/models/category"
import { Post } from "~/models/post"
import { User } from "~/models/user"
import { ApiResponse } from "~/types/api"

export const useGeneralStore = defineStore("general", () => {
	const state = {
		selectedInterestId: ref<number | null>(null)
	}

	const bootstrap = async (formData: BootstrapRequest) => {
		const data = await $fetch<BootstrapResponse>(Bootstrap.url(), {
			...useFetchConfig(),
			method: Bootstrap.method,
			query: formData
		})
		return data.data
	}

	const homepage = async (formData: HomepageRequest) => {
		const data = await $fetch<HomepageResponse>(Homepage.url(), {
			...useFetchConfig(),
			method: Homepage.method,
			query: formData
		})
		return data.data
	}

	const discoverAbortController = ref<AbortController>()
	const discover = async (formData: DiscoverRequest) => {
		discoverAbortController.value?.abort()
		discoverAbortController.value = new AbortController()
		const data = await $fetch<DiscoverResponse>(Discover.url(), {
			...useFetchConfig(),
			signal: discoverAbortController.value?.signal,
			method: Discover.method,
			query: formData
		})
		return data.data
	}

	return {
		...state,
		bootstrap,
		homepage,
		discover
	}
})

// general :: bootstrap
export interface BootstrapRequest {
	profile?: boolean
	metas?: boolean
	blockchains?: boolean
	currencies?: boolean
	categories?: boolean
	businesses?: boolean
	wallets?: boolean
}
export interface BootstrapResponse extends ApiResponse {
	data: {
		profile?: User
		metas?: any
		categories?: Category[]
		businesses?: Business[]
	}
}
const Bootstrap = {
	method: "GET" as "GET",
	url: () => "bootstrap"
}

// general :: homepage
export interface HomepageRequest {}
export interface HomepageResponse extends ApiResponse {
	data: {}
}
const Homepage = {
	method: "GET" as "GET",
	url: () => "homepage"
}

// general :: discover
export interface DiscoverRequest {
	area?: string
	locale?: string
	type?: string
}
export interface DiscoverResponse extends ApiResponse {
	data: {
		posts: Post[]
		businesses: Business[]
	}
}
const Discover = {
	method: "GET" as "GET",
	url: () => "discover"
}

export const useGeneralApiUrl = () => ({
	Bootstrap,
	Homepage,
	Discover
})
